import { IUpdateValue } from '../Utils/BusinessDataFormUtils';
import { append, type, concat } from 'ramda';
import Logger from '../../../../../../../Utils/Logger';

type PathType = Array<number | string>;

const getChangedPaths = (
  value: IUpdateValue,
  currentPath: PathType,
  changedPaths: PathType[]
): PathType[] => {
  Object.keys(value).forEach(key => {
    if (key !== '_version' && key !== 'id' && key !== '_Associations') {
      const changedPath = append(key, currentPath);
      changedPaths = append(changedPath, changedPaths);
    }
  });

  return changedPaths;
};

let changedPaths: PathType[] = [];

changedPaths = getChangedPaths(
  {
    id: 'ArrayKontoNrChangedValue',
    _version: 1,
    _Associations: {
      TestAssociation_Update_Values: [
        {
          id: 'TestAssociation',
          _version: 1,
          KONTO_NR: '44445096',
        },
      ],
    },
  },
  [],
  changedPaths
);

export const getChangedPathsDeep = (
  value: IUpdateValue,
  currentPath: PathType = [],
  changedPaths: PathType[] = []
): PathType[] => {
  changedPaths = getChangedPaths(value, currentPath, changedPaths);

  Object.keys(value).forEach(key => {
    if (key === '_Associations') {
      Object.keys(value._Associations).forEach(associationKey => {
        if (type(value._Associations[associationKey]) === 'Object') {
          changedPaths = getChangedPathsDeep(
            value._Associations[associationKey],
            concat(currentPath, ['_Associations', associationKey]),
            changedPaths
          );
        } else if (type(value._Associations[associationKey]) === 'Array') {
          (value._Associations[associationKey] as any[]).forEach(
            (associationListElement, index) => {
              changedPaths = getChangedPathsDeep(
                associationListElement,
                concat(currentPath, ['_Associations', associationKey, index]),
                changedPaths
              );
            }
          );
        } else if (
          type(value._Associations[associationKey]) === 'String' ||
          type(value._Associations[associationKey]) === 'Null'
        ) {
          const refPath = concat(currentPath, [
            '_Associations',
            associationKey,
          ]);
          changedPaths = append(refPath, changedPaths);
        } else {
          Logger.error(
            Error(
              `Could not handle type: ${type(
                value._Associations[associationKey]
              )}`
            )
          );
        }
      });
    }
  });

  return changedPaths;
};

export const getModelPath = (updateValuePath: PathType): string[] =>
  updateValuePath.reduce<string[]>((previousModelPath, currentPathElement) => {
    if (
      currentPathElement !== '_Associations' &&
      typeof currentPathElement !== 'number'
    ) {
      const modelPathElement = currentPathElement.substring(
        0,
        currentPathElement.indexOf('_')
      );
      return append(modelPathElement, previousModelPath);
    } else {
      return previousModelPath;
    }
  }, []);
